var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"p-1 font-black tracking-wide text-center text-white uppercase rounded",class:[`bg-${_vm.labels[_vm.status]}`],style:('font-size:' + _vm.fontSize + 'rem')},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.labels[_vm.status]))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }